import {
  ReportsReportsCreateFromQuestionDocument,
  ReportsReportsCreateFromQuestionMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export type Report = NonNullable<
  NonNullable<
    ReportsReportsCreateFromQuestionMutation['reportsMutations']['createFromQuestionReportsReport']
  >['report']
>

export default function useQuestion(companyId: number, dashboardId: number) {
  const [rawUpdateQuestion, { data, loading, error }] = useMutation(
    ReportsReportsCreateFromQuestionDocument,
    {
      extractorFn: (data) => data.reportsMutations.createFromQuestionReportsReport,
    }
  )

  const updateQuestion = async (question: string) => {
    const unhandledResult = await rawUpdateQuestion({
      variables: { companyId, dashboardId, question },
    })

    const result = handleResult(unhandledResult, () => undefined)

    if (!result.success) {
      return {
        error: true,
      } as const
    }

    return {
      data: result.data,
      error: false,
    } as const
  }

  const report = data?.reportsMutations.createFromQuestionReportsReport.report

  return {
    updateQuestion,
    report,
    loading,
    error: Boolean(error),
  }
}
